export type Environment = 'development' | 'staging' | 'production';

export default function getEnvironment(): Environment {
    if (process.env.NODE_ENV === 'development') return 'development';

    const { hostname } = window.location;

    if (hostname === 'secure.e-conomic.com') return 'production';
    if (hostname.endsWith('.secure.e-conomic.com')) return 'staging';

    return 'development';
}
